import { inject, injectable, LazyServiceIdentifer } from 'inversify';
import { injectToken, Token } from 'inversify-token';
import { YinzCamAPI, YinzCamAPIRequest, YinzCamAPIRequestComponent, YinzCamAPIResponse, YinzCamAPIToken, YinzCamServer } from 'yinzcam-api';
import { getAppId, getInstallId } from "./utilities";
import _ from "lodash";

export const YinzCamLoyaltyServerToken = new Token<YinzCamLoyaltyServer>(Symbol.for("YinzCamLoyaltyServerToken"));

@injectable()
export class YinzCamLoyaltyServer {
  private readonly server: YinzCamServer;

  public constructor(@injectToken(YinzCamAPIToken) private readonly api: YinzCamAPI) {
    this.server = api.getServer('loyalty');
  }

  public getRequest(request: YinzCamAPIRequest) {
    return this.server.getRequest(request);
  }

  public async getTicket(ssoTicket: string) {
    const data = { "UMS": { "Ticket": `${ssoTicket}` } };
    const ticket = await this.server.singleRequest({
      path: `/ticket`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data
    });
    return ticket;
  }

  public async getHubProgramSingle() {
    return await this.server.singleRequest({
      path: `/hub/program`,
      method: 'GET',
      requiredHeaders: [ 'X-YinzCam-Ticket' ]
    }).then(res => {
      return res.data;
    });
  }

  public getHubProgramComponent(): YinzCamAPIRequestComponent {
    return this.server.getRequest({
      path: '/hub/program',
      headers: {
      },
      params: {
      }
    });
  }

  public async postPointcodeSubmit(pointcode: string, codeType: string) {
    return await this.server.singleRequest({
      path: `/pointcode/submit`,
      method: 'POST',
      requiredHeaders: [ 'X-YinzCam-Ticket' ],
      data: {
        Pointcode: pointcode,
        CodeType: codeType
      }
    }).then(res => {
      return res.data;
    });
  }

  public async postAppSubmitSync(requirementName: string, tags?: { [key: string]: string }) {
    const entries = (tags)? Object.entries(tags).filter(e => !_.isNil(e[1])).map(e => ({ Key: e[0], Value: e[1] })) : [];
    const data = {
      "Segment": [{
        "Meta": {
          "AppId": getAppId(),
          "InstallId": getInstallId(),
          "ClientSequenceNumber": Math.floor(Date.now()/1000)
        },
        "Entry": [{
          "Timestamp": Math.floor(Date.now()/1000),
          "Tag": [{
              "Key": "name",
              "Value": requirementName
            },
            ...entries
          ]
        }]
      }]
    };
    return await this.server.singleRequest({
      path: `/app/submit`,
      method: 'POST',
      requiredHeaders: [ 'X-YinzCam-Ticket' ],
      params: {
        async: 'false'
      },
      data
    }).then(res => {
      return res.data;
    });
  }

  public async postHubRewardRedeem(rewardId: string) {
    return await this.server.singleRequest({
      path: `/hub/rewards/${rewardId}/redeem`,
      method: 'POST',
      requiredHeaders: [ 'X-YinzCam-Ticket' ],
      data: {
        "ContactInfo": {
          "PreferredAddress2": "",
          "FacebookUserName": "",
          "PreferredUserEmail": "",
          "PreferredUserPhone": "",
          "PreferredCity": "",
          "PreferredAddress1": "",
          "PreferredUserName": "",
          "FacebookUserEmail": ""
        },
        "RewardID": rewardId,
        "PickupLocation": "",
        "Quantity": 1
      }
    }).then(res => {
      return res.data;
    });
  }
}
